import { atom } from "recoil";
import { IAgencyMappingsDetails, SelectedRowsToDelete } from "../types";

export const addStateAgencyMapping = atom({
  key: "addStateAgencyMapping",
  default: false,
});
export const editStateAgencyMapping = atom({
  key: "editStateAgencyMapping",
  default: false,
});

export const selectedRowsStateAgencyMapping = atom({
  key: "selectedRowsStateAgencyMapping",
  default: [],
});

export const selectedRowsToDelete = atom<SelectedRowsToDelete | undefined>({
  key: "selectedRowsToDelete",
  default: undefined,
});

export const rowForEditAgencyMapping = atom<IAgencyMappingsDetails | undefined>(
  {
    key: "rowForEditAgencyMapping",
    default: undefined,
  }
);

export const agencyMappingsSaving = atom({
  key: "agencyMappingsSaving",
  default: false,
});
